import { NzModalService, NzModalRef } from 'ng-zorro-antd/modal';
import { PackageFormComponent } from './package-form.component';

/**
 * Opens the package create/edit form as a modal. Pass `packageId` to edit,
 * omit it to create. afterClose emits `true` when a package was saved, so the
 * opener can refresh its list/view. The form is modal-aware and falls back to
 * route mode when reached via /new or /:id/edit directly.
 */
export function openPackageFormModal(
  modal: NzModalService,
  opts: { packageId?: string; title: string }
): NzModalRef<PackageFormComponent, boolean> {
  return modal.create<PackageFormComponent, { packageId?: string }, boolean>({
    nzTitle: opts.title,
    nzContent: PackageFormComponent,
    nzData: { packageId: opts.packageId },
    nzWidth: 760,
    nzFooter: null,
    nzMaskClosable: false,
  });
}
